/** The list's groups, in the order they are shown. */
export var TripGroupKind;
(function (TripGroupKind) {
    /** Trips ending today or later, soonest start first (a trip in progress comes first). */
    TripGroupKind["UPCOMING"] = "UPCOMING";
    /** Trips without dates, newest first. */
    TripGroupKind["NO_DATES_YET"] = "NO_DATES_YET";
    /** Trips that ended before today, most recent end first. */
    TripGroupKind["PAST"] = "PAST";
})(TripGroupKind || (TripGroupKind = {}));
/** Groups the owner's trips as drawn (Tal, phase 01), using the owner's local today. */
export class TripListGrouping {
    todaySource;
    constructor(todaySource) {
        this.todaySource = todaySource;
    }
    groupTrips(trips) {
        const today = this.todaySource.today();
        const datedTrips = this.datedTripsOf(trips);
        const upcoming = datedTrips.filter(datedTrip => !datedTrip.dateRange.endsBefore(today)).sort((first, second) => this.compareSoonestStartFirst(first, second));
        const past = datedTrips.filter(datedTrip => datedTrip.dateRange.endsBefore(today)).sort((first, second) => this.compareMostRecentEndFirst(first, second));
        const tripsWithoutDates = trips.filter(trip => trip.dateRange.get() === undefined).sort((first, second) => this.compareNewestFirst(first, second));
        const groups = [
            { kind: TripGroupKind.UPCOMING, trips: upcoming.map(datedTrip => datedTrip.trip) },
            { kind: TripGroupKind.NO_DATES_YET, trips: tripsWithoutDates },
            { kind: TripGroupKind.PAST, trips: past.map(datedTrip => datedTrip.trip) }
        ];
        return groups.filter(group => group.trips.length > 0);
    }
    datedTripsOf(trips) {
        const datedTrips = [];
        for (const trip of trips) {
            const dateRange = trip.dateRange.get();
            if (dateRange !== undefined) {
                datedTrips.push({ trip, dateRange });
            }
        }
        return datedTrips;
    }
    compareSoonestStartFirst(first, second) {
        const dayDifference = this.compareDays(first.dateRange.getStart(), second.dateRange.getStart());
        return dayDifference === 0 ? this.compareNewestFirst(first.trip, second.trip) : dayDifference;
    }
    compareMostRecentEndFirst(first, second) {
        const dayDifference = this.compareDays(second.dateRange.getEnd(), first.dateRange.getEnd());
        return dayDifference === 0 ? this.compareNewestFirst(first.trip, second.trip) : dayDifference;
    }
    compareDays(first, second) {
        return first.toIsoText().localeCompare(second.toIsoText());
    }
    compareNewestFirst(first, second) {
        const timeDifference = second.createdAt.get().getTime() - first.createdAt.get().getTime();
        return timeDifference === 0 ? second.getId().localeCompare(first.getId()) : timeDifference;
    }
}
//# sourceMappingURL=TripListGrouping.js.map